import { Stack, Text } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import OemConverged from "public/privateCloud/oem-converged-architecture.webp";

type DescCompProps = {
  description: string[];
};

const DescComp = (props: DescCompProps) => {
  const TextVariant = useTextVariants();
  const { description } = props;
  return (
    <Stack spacing={2}>
      {description.map((desc, index) => (
        <Text key={index} variant={TextVariant} color="text.100">
          {desc}
        </Text>
      ))}
    </Stack>
  );
};

export const INTRO_CONSTANTS = {
  heading: "OEM Converged Architecture ",
  description: (
    <DescComp
      description={[
        "Integrating OEM systems into a cohesive cloud strategy can be complex—but OneMind simplifies it. We offer a Multi-Vendor Hosted Converged Cloud, partnering with industry-leading OEMs like Dell, Cisco, Pure Storage, and NetApp to deliver powerful private cloud solutions tailored to enterprise needs.",
        "Our approach to OEM Converged Architecture focuses on harmonizing devices, hardware, and software within a unified, cloud-native environment that supports agility at scale. By leveraging standardized compute, networking, and security frameworks, we enable seamless interoperability across cloud, edge, and hybrid deployments. The result is an infrastructure that not only performs efficiently but also scales intelligently—with minimal overhead.",
        "With OneMind managing the convergence, organizations gain greater control, visibility, and security across their ecosystem—without the traditional integration challenges.",
      ]}
    />
  ),
  points: [
    "Optimized infrastructure for OEM applications ",
    "Seamless integration with existing IT systems ",
    "Enhanced security, performance, and scalability",
  ],
  image: OemConverged,
};
